import React, { ReactNode } from 'react';
import { ChevronDownIcon } from '@radix-ui/react-icons';

import { DropdownMenu } from '../modals/dropdown-menu/DropdownMenu';

import styles from './split-button.module.scss';

type Item = {
  onSelect: (event: Event) => void;
  title: ReactNode;
  icon?: ReactNode;
  type?: 'danger' | 'warning';
  disabled?: boolean;
  tooltipText?: string;
};

type AddBlockButtonProps = {
  /**
   * Styling hook for call sites that need to reach this button from their own stylesheet, e.g.
   * `[data-split-button='download-share-button']`. A `data-*` attribute rather than an `id`
   * because CSS Modules rewrites id selectors but leaves attribute selectors alone — and because
   * a component can render more than once on a page (PRO-1082 fallout).
   */
  name?: string;
  text: string;
  items: Item[];
  onClick?: () => void;
  icon?: ReactNode;
};

export const SplitButton: React.FC<AddBlockButtonProps> = ({ name, text, icon, items }) => (
  <DropdownMenu
    items={items}
    trigger={
      <div className={styles['button-container']} data-split-button={name}>
        <button className={styles['button']}>
          {icon}
          {text}
        </button>

        <button className={styles['open-select-button']}>
          <ChevronDownIcon />
        </button>
      </div>
    }
  />
);
